export enum ReservationLocalstorageSteps {
  FIRSTSTEP = 'firstStep',
  SECONDSTEP = 'secondStep',
  THIRDSTEP = 'thirdStep',
  THIRDSTEP_TOTAL_RESERV_AMOUNT = 'thirdStepTotalReservAmount',
  FOURTHSTEP = 'fourthStep',
  //   FOURTHSTEP_RESERVATION_ID = 'fourthStepReservationId',
}

export enum StepThreeCalculations {
  SERVICES = 'services',
  DISCOUNTS = 'discounts',
}

export type TpriceListRulesValidation = {
  [index: string]: string;
};

export const priceListRules: TpriceListRulesValidation = {
  'ERROR-VALIDACIJA-OVERBOOK': 'Preklapanje rezervacija',
  'ERROR-VALIDACIJA-MINBRDANA': 'Minimalni broj dana rezervacije',
  'ERROR-VALIDACIJA-DANIUSLUGA': 'Dani dolaska i odlaska',
  'ERROR-VALIDACIJA-DANIODLASKA': 'Dani odlaska',
  'ERROR-VALIDACIJA-MAXOSOBA': 'Maximalni broj osoba',
  'ERROR-VALIDACIJA-USLUGE': 'Cjenik nije definiran za odabranu uslugu u odabranom periodu',
};

export enum EPriceListRulesValidation {
  'ERROR-VALIDACIJA-OVERBOOK' = 'ERROR-VALIDACIJA-OVERBOOK',
  'ERROR-VALIDACIJA-MINBRDANA' = 'ERROR-VALIDACIJA-MINBRDANA',
  'ERROR-VALIDACIJA-DANIUSLUGA' = 'ERROR-VALIDACIJA-DANIUSLUGA',
  'ERROR-VALIDACIJA-DANIODLASKA' = 'ERROR-VALIDACIJA-DANIODLASKA',
  'ERROR-VALIDACIJA-MAXOSOBA' = 'ERROR-VALIDACIJA-MAXOSOBA',
  'ERROR-VALIDACIJA-USLUGE' = 'ERROR-VALIDACIJA-USLUGE',
}

export const priceListRulesValidationErrors = [
  'ERROR-VALIDACIJA-OVERBOOK',
  'ERROR-VALIDACIJA-MINBRDANA',
  'ERROR-VALIDACIJA-DANIUSLUGA',
  'ERROR-VALIDACIJA-DANIODLASKA',
];

export const reservationTransfer = {
  GA: 'Gost -> agencija',
  GI: 'Gost -> iznajmljivač',
  AI: 'Agencija -> iznajmljivač',
  AG: 'Agencija -> gost',
  IA: 'Iznajmljivač -> agencija',
};

export enum EReservationTransfer {
  GA = 'GA',
  GI = 'GI',
  AI = 'AI',
  AG = 'AG',
  IA = 'IA',
}
